import { Menu, MenuButton, MenuItems, MenuItem, Transition } from "@headlessui/react";
import { Fragment, useState } from "react";
import remarkGfm from "remark-gfm";
import markdown from "../../../../CHANGELOG.md?raw";
import ModalConfirm from "../components/modals/ModalConfirm";
import { useThemeContext } from "../utils/services/HandleThemeToggling";

import ReactMarkdown from "react-markdown";
export const PaceteqLogo = ({
  classNames,
  collapsed,
  testId,
}: {
  classNames: string;
  collapsed: boolean;
  testId: string;
}) => {
  const { isDarkMode } = useThemeContext();
  const [showChangelog, setShowChangelog] = useState(false);

  const menuActions = [
    {
      title: "Show Changelog",
      onClick: () => setShowChangelog(true),
    },
    {
      title: "Report an Issue",
      onClick: () => window.open("https://share-eu1.hsforms.com/114JYUA3pRiuhDI1njI5jbQ2dxhuj", "_blank"),
    },
  ];

  return (
    <div>
      <Menu as="div" className="relative inline-block text-left w-full">
        {({ open }) => (
          <>
            <MenuButton className={`${classNames} cursor-pointer`} data-testid={testId}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox={collapsed ? "0 0 429.71 429.71" : "0 0 1920 429.71"}
                className="w-full h-full"
                fill={isDarkMode ? "#f7f5f2" : "#000c2b"}>
                {!collapsed && (
                  <g>
                    <path d="M710.96,174.26c0-45.71-27.56-76.96-88.06-76.96h-92.42v235.27h44.03v-81.67h48.4c60.5,0,88.06-31.26,88.06-76.63h-.01ZM621.22,212.24h-46.72v-76.29h46.72c30.25,0,44.36,14.45,44.36,38.31s-14.12,37.98-44.36,37.98Z" />
                    <path d="M773.62,97.29l-86.38,235.27h46.38l16.8-48.06h102.51l16.8,48.06h46.72l-86.37-235.27h-56.46,0ZM762.19,251.56l38.32-108.89h2.69l38.31,108.89h-79.32Z" />
                    <path d="M1021.48,132.59c26.22,0,47.06,13.11,54.11,42.68h43.02c-5.38-55.45-45.71-81-96.12-81-66.55,0-109.57,44.03-109.57,120.66s43.02,120.99,109.23,120.99c50.75,0,91.08-25.54,96.46-81.67h-43.02c-7.06,30.25-27.89,43.35-54.11,43.35-43.36,0-63.52-33.94-63.52-82.68s20.84-82.34,63.52-82.34h0Z" />
                    <polygon points="1189.96 230.39 1293.48 230.39 1293.48 195.77 1189.96 195.77 1189.96 135.95 1303.56 135.95 1303.56 97.29 1145.93 97.29 1145.93 332.56 1306.92 332.56 1306.92 293.91 1189.96 293.91 1189.96 230.39" />
                    <polygon points="1321.89 136.62 1391.8 136.62 1391.8 332.56 1435.83 332.56 1435.83 136.62 1505.73 136.62 1505.73 97.29 1321.89 97.29 1321.89 136.62" />
                    <polygon points="1568.29 230.39 1671.81 230.39 1671.81 195.77 1568.29 195.77 1568.29 135.95 1681.89 135.95 1681.89 97.29 1524.27 97.29 1524.27 332.56 1685.25 332.56 1685.25 293.91 1568.29 293.91 1568.29 230.39" />
                    <path d="M1920,214.93c0-73.94-45.04-120.66-110.91-120.66s-110.58,46.72-110.58,120.66,44.7,120.99,110.58,120.99c23.86,0,45.04-6.38,62.51-17.81l20.84,21.18,26.55-25.21-21.17-21.51c14.12-20.17,22.18-46.72,22.18-77.64h0ZM1865.89,260.3l-32.27-32.6-26.55,25.21,35.29,35.63c-9.41,6.05-20.5,9.08-33.27,9.08-40.33,0-65.2-31.26-65.2-82.68s24.87-82.34,65.2-82.34,65.2,30.58,65.2,82.34c0,17.81-3.03,32.93-8.4,45.37h0Z" />
                  </g>
                )}
                <g>
                  <polygon points="265.24 291.42 168.25 347.42 168.25 429.71 168.25 429.71 336.51 332.57 336.51 138.29 265.24 179.43 265.24 291.42" />
                  <polygon points="71.27 209.13 71.27 97.14 0 56 0 250.28 168.25 347.42 168.25 265.13 71.27 209.13" />
                  <polygon points="239.52 82.29 336.51 138.29 407.77 97.14 239.52 0 71.27 97.14 142.53 138.29 239.52 82.29" />
                </g>
              </svg>
            </MenuButton>

            <Transition
              show={open}
              as={Fragment}
              enter="transition ease-out duration-100"
              enterFrom="transform opacity-0 scale-95"
              enterTo="transform opacity-100 scale-100"
              leave="transition ease-in duration-75"
              leaveFrom="transform opacity-100 scale-100"
              leaveTo="transform opacity-0 scale-95">
              <MenuItems
                static
                className="absolute left-0 bottom-full mb-2 w-56 origin-bottom-left border bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none dark:border-gray-600 dark:bg-black z-50">
                <div>
                  {menuActions.map(action => (
                    <MenuItem key={action.title}>
                      {({ focus }) => (
                        <button
                          type="button"
                          className={`${
                            focus
                              ? "bg-gray-100 text-gray-900 dark:bg-gray-700 dark:text-gray-100"
                              : "text-gray-700 dark:text-gray-300"
                          } block w-full text-left px-4 py-2 text-sm`}
                          onClick={action.onClick}>
                          {action.title}
                        </button>
                      )}
                    </MenuItem>
                  ))}
                </div>
              </MenuItems>
            </Transition>
          </>
        )}
      </Menu>

      {showChangelog && (
        <ModalConfirm open={showChangelog} setOpen={setShowChangelog} onConfirm={() => {}}>
          <div className="text-left [&_li]:list-disc">
            <ReactMarkdown remarkPlugins={[remarkGfm]}>{markdown}</ReactMarkdown>
          </div>
        </ModalConfirm>
      )}
    </div>
  );
};
